module.exports = __webpack_public_path__ + "img/DCIcase.5bbc6c6d.png";